var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPoin = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 18,
  height: 18,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#FFC843",
  d: "M9 17.25A8.25 8.25 0 1 0 9 .75a8.25 8.25 0 0 0 0 16.5"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#D38700",
  d: "M9 15.416A6.417 6.417 0 1 0 9 2.583a6.417 6.417 0 0 0 0 12.833"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#FFC843",
  d: "m9.274 5.59.917 1.87c.036.092.128.147.238.165l2.053.293c.257.037.349.349.165.532l-1.485 1.448a.32.32 0 0 0-.091.275l.348 2.053c.037.257-.22.44-.458.33l-1.834-.971a.28.28 0 0 0-.293 0l-1.833.971c-.22.129-.495-.073-.459-.33l.349-2.053a.3.3 0 0 0-.092-.275L5.314 8.45c-.183-.183-.092-.495.165-.532l2.053-.293a.32.32 0 0 0 .239-.165l.916-1.87c.147-.238.477-.238.587 0"
})));
export default SvgPoin;